import { createTableStore, type FilterFieldConfig } from './table-store';

// Sequence filter config
export const SEQUENCE_FILTER_CONFIG: FilterFieldConfig<Record<string, unknown>>[] = [
  { key: 'status', label: 'Status' },
  { key: 'triggerType', label: 'Trigger' },
  {
    key: 'tagIds',
    label: 'Tags',
    format: (v) => (Array.isArray(v) ? `${v.length} selected` : String(v)),
  },
];

// Sequence filter type
export interface SequenceFilterData {
  status?: string;
  triggerType?: string;
  tagIds?: string[];
  [key: string]: unknown;
}

// Sequence table store
export const useSequenceTableStore = createTableStore<SequenceFilterData>(
  SEQUENCE_FILTER_CONFIG as FilterFieldConfig<SequenceFilterData>[],
  { defaultSortBy: 'createdAt', defaultSortOrder: 'desc', storeName: 'sequence' },
);
